<template>
    <input
        :class="$props.class"
        type="text"
        v-model="exp_date"
        :name="$props.name"
        :id="$props.id"
        maxlength="7"
        :placeholder="$props.placeholder"
        :required="$props.required"
        @input="onExpDate"
    >
</template>

<script>
    export default {
        props: {
            id: {
                type: String,
                default: 'exp_date'
            },
            value: {
                type: String,
            },
            name: {
                type: String,
                default: 'exp_date'
            },
            class: {
                type: String,
                default: 'form-control'
            },
            placeholder: {
                type: String,
                default: null
            },
            required: {
                type: Boolean,
                default: false
            },
            clearData: {
                type: Boolean,
                default: false
            },
            modelValue: {
                type: String,
                required: false,
                default: null
            },
        },
        emits: ['onExpDate', 'update:modelValue'],
        data() {
            return {
                exp_date: ''
            }
        },
        watch: {
            clearData(value){
                if(value){
                    this.exp_date = '';
                }
            },
            value(value){
                if(value){
                    this.exp_date = value;
                }
            }
        },
        methods: {
            onExpDate() {
                let chars = this.exp_date.length;

                if (chars === 2) {
                    this.exp_date = this.formatString('{0}{1} / ', ...this.exp_date.split(''));

                } else if (chars === 5 && this.exp_date.substring(2, 5) === ' / ') {
                    this.exp_date = this.exp_date.replace(' / ', '');

                } else if (chars > 2 && chars < 5) {
                    this.exp_date = this.formatString('{0}{1} / {2}{3}', ...this.exp_date.split(''));

                    this.exp_date = this.exp_date.replaceAll(/{(\d+)}/g, '');

                } else if (chars > 7) {
                    this.exp_date = this.exp_date.substring(0, 7);
                }

                this.$emit('onExpDate', this.exp_date);
                this.$emit('update:modelValue', this.exp_date.replaceAll(' ', ''));
            },

            formatString(template, ...args){
                return template.replace(/{([0-9]+)}/g, function (match, index) {
                  return typeof args[index] === 'undefined' ? match : args[index];
                });
            }

        }
    }

</script>
